// extracted by mini-css-extract-plugin
export default {"dniUpload":"DNIUpload_dniUpload__POpet","tips":"DNIUpload_tips__aNkLK","readyButton":"DNIUpload_readyButton__SoHtk","successPage":"DNIUpload_successPage__hfaGN"};